import { incYenOf, incOf } from '../lib/pricing';
export const luxurySalesHero = {
  title: 'ラグジュアリー営業向け 法人研修',
  titleEn: 'FOR LUXURY SALES',
  lead: 'ラグジュアリー営業向け研修は、高額商談の体験を所作から設計し直す、執事流の実技プログラムです。',
  targetNote: '対象: 高級輸入車ディーラー・宝飾時計サロン・高級不動産仲介',
};

export const luxurySalesTrustBadges = [
  {
    icon: 'ri-vip-crown-line',
    text: '高額商談の体験を所作から設計',
  },
  {
    icon: 'ri-store-2-line',
    text: '出張型で貴社のショールーム・モデルルームにて実施',
  },
  {
    icon: 'ri-user-star-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const luxurySalesPainPoints = [
  {
    icon: 'ri-emotion-unhappy-line',
    text: '商品力は十分なのに、接遇が価格帯の期待に追いついていません。数千万円の商談では、商品説明の上手さよりも、その場の体験の質が記憶に残ります。',
  },
  {
    icon: 'ri-route-line',
    text: 'ショールーム・内見での「お迎えからお見送りまで」の一連が設計されておらず、担当者ごとの個人技に任されています。体験にムラがあることが、機会損失につながっています。',
  },
  {
    icon: 'ri-gift-2-line',
    text: '納車式・お引渡しという最大の見せ場を十分に演出し切れていません。せっかくの感動の瞬間が、手続きの延長になっていないでしょうか。',
  },
  {
    icon: 'ri-chat-heart-line',
    text: '紹介でつながる市場ゆえ、一度の粗相が評判に響きます。高額商談ほど「誰から買うか」で選ばれるため、すべての接点で期待値を超える必要があります。',
  },
];

export const whyButlerWorks = [
  {
    icon: 'ri-home-smile-line',
    title: '富裕層の「当たり前の水準」から所作を組み立てる',
    description:
      '執事は富裕層の生活様式と価値観を最も近くで学んできた職業です。お客様が日常的に経験しているサービスの水準を知る講師が、その目線から所作を組み立て直します。「これくらいで十分」ではなく「これが当然」から出発します。',
  },
  {
    icon: 'ri-service-line',
    title: 'モノの扱いを美しく見せる手元の技術',
    description:
      '鍵・書類・宝飾品といった高額商材を扱う手元の所作は、お客様が無意識に注視しているポイントです。執事が培ってきた「モノを美しく扱う」手元の技術を実技で移植し、商談の説得力を高めます。',
  },
  {
    icon: 'ri-drinks-line',
    title: '商談を「売る場」から「もてなす場」へ変える',
    description:
      '商談体験そのものを「もてなし」として設計することで、お客様の記憶に残り、紹介につながる関係性を築きます。押し付けがましさのない、自然な信頼構築の技術を提供します。',
  },
];

export const recommendedPrograms = [
  {
    title: '半日プラン例',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    modules: 'M1（立ち居振る舞い）＋ M3（お茶出し・商談卓の整え実技）',
    description:
      'ショールームやモデルルームでのお迎えから商談卓までの所作に集中する短期プランです。まずは基本の型を体得する導入研修としてご利用いただけます。',
  },
  {
    title: '1日プラン例',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    modules: 'M1 ＋ M2（VIP・富裕層対応の原則）＋ M3 ＋ M4（同伴者対応・想定外対応ロールプレイング）',
    description:
      '所作からVIP対応、ご家族・同伴者への気配りまで、ラグジュアリー商談の接遇基盤を1日で網羅する推奨プランです。',
    recommended: true,
  },
  {
    title: '納車式・お引渡しの所作設計',
    duration: '1日（6時間）',
    price: incYenOf('ct-single-fullday'),
    modules: '研修に加え、貴社の引渡しフローを執事の視点で組み直す回',
    description:
      '現状の引渡しフローを確認し、鍵や書類の差し出し方、布の掛け外し、記念のひとことまで、儀式としての一連を設計し実技で磨きます。',
  },
];

export const luxurySalesScenarios = [
  {
    number: '01',
    title: 'ショールーム・内見のエスコート',
    description:
      'お出迎えの距離とタイミング、ご案内の歩く位置と速度、試乗・内見中の声がけと沈黙の使い分けを通しで演習します。お客様に「見られている」感覚を与えず、自然に商品の魅力を引き立てる所作を磨きます。',
    imageSeq: 'luxury-sales-scenario-1',
  },
  {
    number: '02',
    title: '納車式・お引渡しの所作',
    description:
      '鍵や書類の両手での差し出し方、専用クロスの掛け外しの所作、記念のひとことまで、お引渡しを「儀式」として一連設計し実技で磨きます。お客様の人生の節目にふさわしい体験を、全担当者が同じ水準で実施できるようにします。',
    imageSeq: 'luxury-sales-scenario-2',
  },
  {
    number: '03',
    title: 'ご家族・同伴者への気配り',
    description:
      'お子様連れやご高齢の同伴者への席のご案内、年齢に応じた飲み物のご提案、商談中の同伴者の待ち時間への配慮をロールプレイングします。ご家族の満足度が、最終的なご成約を後押しするケースは少なくありません。',
    imageSeq: 'luxury-sales-scenario-3',
  },
];

export const luxurySalesTargetRoles = [
  'セールスコンサルタント',
  'ショールーム受付',
  '店長・営業責任者',
  '納車・引渡し担当',
  'カスタマーリレーション担当',
];

export const luxurySalesPricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '2日間パッケージ',
    duration: '2日間（各6時間）',
    price: incYenOf('ct-single-2day'),
    note: '全モジュール対応',
  },
  {
    name: '継続プログラム',
    duration: '月1回半日×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    note: '定着と改善を繰り返す長期設計',
  },
];

export const luxurySalesPricingConditions = {
  dispatch: '出張時の交通費は実費別途',
  capacity: '推奨12名まで。超過する場合は2班制等をご提案します',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
  nightAvailable: 'ショールーム・モデルルームでの出張実施に対応。閉店後の夜間開催も可能です。',
};

export const luxurySalesFlowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description:
      '商談フロー・課題・希望時期などをオンラインまたはお電話で伺います。事前に研修内容資料をお送りすることも可能です。',
  },
  {
    step: '03',
    title: 'プログラム提案・お見積り',
    description:
      'ヒアリング内容をもとに、貴社に最適な研修プログラムとお見積りをご提案します。稟議用の概算お見積りのみのご依頼でも構いません。',
  },
  {
    step: '04',
    title: '実施',
    description:
      '出張または来校にて研修を実施します。出張型では貴社のショールーム・モデルルームで実施し、実際の商談動線で訓練することで研修翌日からの再現性が高まります。閉店後の夜間開催にも対応します。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const businessTypeOptions = [
  { value: '', label: '選択してください' },
  { value: 'import-car', label: '輸入車' },
  { value: 'domestic-luxury-car', label: '国産高級車' },
  { value: 'jewelry-watch', label: '宝飾時計' },
  { value: 'luxury-realestate', label: '高級不動産' },
  { value: 'other', label: 'その他' },
];

export const luxurySalesFormatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const luxurySalesFaqs = [
  {
    question: '執事の資格が取れる研修ですか？',
    answer:
      'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  },
  {
    question: '納車式やお引渡しの演出設計だけを依頼できますか？',
    answer:
      'はい。「納車式・お引渡しの所作設計（1日）」として、現状フローの確認から所作の組み直し、通し稽古までを1日で行います。',
  },
  {
    question: '自社の商談フローに合わせてもらえますか？',
    answer:
      'はい。ヒアリングで商談の流れを伺い、演習シナリオを貴社仕様に差し替えて実施します。貴社の商材やお客様層に即した内容で研修を組み立てます。',
  },
  {
    question: 'トップ営業1名への個人指導はできますか？',
    answer:
      'プライベート研修（半日220,000円税込〜）として承ります。内容と会場はご相談ください。',
  },
];

export const luxurySalesRelatedPages = [
  {
    title: 'ホテル・旅館',
    description: 'バトラーサービスの型を開業前に整える',
    href: '/corporate/hotel',
  },
  {
    title: '高級レジデンス',
    description: 'コンシェルジュ・フロントの接遇品質を統一',
    href: '/corporate/residence',
  },
  {
    title: '金融・プライベートバンク',
    description: '富裕層営業の所作と距離感を鍛える',
    href: '/corporate/finance',
  },
  {
    title: '百貨店外商・高級小売',
    description: 'お得意様対応と訪問の作法',
    href: '/corporate/retail',
  },
  {
    title: '医療・美容クリニック',
    description: '自由診療の接遇を院内に定着',
    href: '/corporate/clinic',
  },
  {
    title: '自動車・モビリティ',
    description: 'ブランド体験の接遇を高める',
    href: '/corporate/automotive',
  },
  {
    title: 'ハイヤー・送迎',
    description: '乗降の所作と車内の気配りを磨く',
    href: '/corporate/chauffeur',
  },
];